import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import Swiper from "react-id-swiper";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faCar,
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import './grandi10sedan.css';
/****Fotos Banner ****/
import Slider1 from "../../images/modelos/grandi10sedan2023/banner/banner1.webp";
import Slider2 from "../../images/modelos/grandi10sedan2023/banner/banner2.webp";
import Slider3 from "../../images/modelos/grandi10sedan2023/banner/banner3.webp";
import Slider4 from "../../images/modelos/grandi10sedan2023/banner/banner4.webp";
import Slider5 from "../../images/modelos/grandi10sedan2023/banner/banner5.webp";
/****Fotos calidad de tiempo ****/
import CalidadVideo from "../../images/modelos/grandi10sedan2023/calidad/video.mp4";
import Deportivo from "../../images/modelos/grandi10sedan2023/calidad/calidad1.webp";
import Espacioso from "../../images/modelos/grandi10sedan2023/calidad/calidad2.webp";
import Galeria1 from "../../images/modelos/grandi10sedan2023/galeria/galeria1.webp";
import Galeria2 from "../../images/modelos/grandi10sedan2023/galeria/galeria2.webp";
import Galeria3 from "../../images/modelos/grandi10sedan2023/galeria/galeria3.webp";
import Galeria4 from "../../images/modelos/grandi10sedan2023/galeria/galeria4.webp";
import Galeria5 from "../../images/modelos/grandi10sedan2023/galeria/galeria5.webp";
/****Fotos disenio ****/
import Interior2 from "../../images/modelos/grandi10sedan2023/disenio/interior2.webp";
import Interior3 from "../../images/modelos/grandi10sedan2023/disenio/interior3.webp";
import Interior4 from "../../images/modelos/grandi10sedan2023/disenio/interior4.webp";
import Interior5 from "../../images/modelos/grandi10sedan2023/disenio/interior5.webp";
import Interior6 from "../../images/modelos/grandi10sedan2023/disenio/interior6.webp";
import Interior7 from "../../images/modelos/grandi10sedan2023/disenio/interior7.webp";
/****Fotos rendimiento ****/
import rendimiento1 from "../../images/modelos/grandi10sedan2023/rendimiento/rendimiento1.webp";
import rendimiento2 from "../../images/modelos/grandi10sedan2023/rendimiento/rendimiento2.webp";
import rendimiento3 from "../../images/modelos/grandi10sedan2023/rendimiento/rendimiento3.webp";
/****Fotos seguridad ****/
import seguridad1 from "../../images/modelos/grandi10sedan2023/seguridad/seguridad1.webp";
import seguridad2 from "../../images/modelos/grandi10sedan2023/seguridad/seguridad2.webp";
import seguridad3 from "../../images/modelos/grandi10sedan2023/seguridad/seguridad3.webp";
import seguridad4 from "../../images/modelos/grandi10sedan2023/seguridad/seguridad4.webp";
import seguridad5 from "../../images/modelos/grandi10sedan2023/seguridad/seguridad5.webp";
import seguridad6 from "../../images/modelos/grandi10sedan2023/seguridad/seguridad6.webp";
/****Fotos conveniencia ****/
import conveniencia1 from "../../images/modelos/grandi10sedan2023/conveniencia/conveniencia1.webp";
import conveniencia2 from "../../images/modelos/grandi10sedan2023/conveniencia/conveniencia2.webp";
import conveniencia3 from "../../images/modelos/grandi10sedan2023/conveniencia/conveniencia3.webp";
import conveniencia4 from "../../images/modelos/grandi10sedan2023/conveniencia/conveniencia4.webp";
import conveniencia5 from "../../images/modelos/grandi10sedan2023/conveniencia/conveniencia5.webp";
import conveniencia6 from "../../images/modelos/grandi10sedan2023/conveniencia/conveniencia6.webp";
import conveniencia7 from "../../images/modelos/grandi10sedan2023/conveniencia/conveniencia7.webp";
import final_conveniencia from "../../images/modelos/grandi10sedan2023/conveniencia/final-conveniencia.webp";
/***showroom virtual */
import ShowRoom from "../../images/showroom/grandi10sedan.png";

function InfoGrandi10Sedan2023() {
    const [gallerySwiper, getGallerySwiper] = useState(null);
    const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
    const gallerySwiperParams = {
        getSwiper: getGallerySwiper,
        // spaceBetween: 10,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    };

    const thumbnailSwiperParams = {
        getSwiper: getThumbnailSwiper,
        // spaceBetween: 10,
        slidesPerView: 5,
        loop: true,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
    };

    useEffect(() => {
        if (
            gallerySwiper !== null &&
            gallerySwiper.controller &&
            thumbnailSwiper !== null &&
            thumbnailSwiper.controller
        ) {
            gallerySwiper.controller.control = thumbnailSwiper;
            thumbnailSwiper.controller.control = gallerySwiper;
        }
    }, [gallerySwiper, thumbnailSwiper]);

    const onChangeMenu = (menu) => {
        switch (menu) {
            case "calidad":
                document.getElementById("tab-calidad").className = "color-hover";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-block";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider1;
                break;
            case "disenio":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-hover";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-block";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider2;
                break;
            case "rendimiento":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-hover";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-block";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider3;
                break;
            case "seguridad":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-hover";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-block";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider4;
                break;
            case "conveniencia":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-hover";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-block";
                document.getElementById("img-carrusel").src = Slider5;
                break;
            default:
                break;
        }
    };

    return (
        <Fragment>
            <link rel="preload" as="image" href={Slider1} />
            <link rel="preload" as="image" href={Deportivo} />
            <link rel="preload" as="image" href={Espacioso} />
            <link rel="preload" as="image" href={Galeria1} />
            <link rel="preload" as="image" href={Galeria2} />
            <link rel="preload" as="image" href={Galeria3} />
            <link rel="preload" as="image" href={Galeria4} />
            <link rel="preload" as="image" href={Galeria5} />
            <Container fluid={true}>
                <Row>
                    <Col md={12} className="px-0">
                        <div>
                            <Image
                                src={Slider1}
                                className="banner"
                                alt="Grandi10 Banner"
                                id="img-carrusel"
                                fluid
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="menu-vehiculo sticky-top">
                <Container>
                    <Row className="py-2 py-md-4">
                        <Col xs={2} md={2} className="my-auto d-none d-sm-block">
                            <h1 className="menu-modelo">GRAND i10 Sedán</h1>
                        </Col>
                        <Col
                            xs={12}
                            md={7}
                            className="my-auto vehiculo-item text-md-center"
                        >
                            <ul className="my-auto p-0 m-0">
                                <li
                                    id="tab-calidad"
                                    onClick={() => onChangeMenu("calidad")}
                                    className="color-hover"
                                >
                                    Calidad de tiempo
                                </li>
                                <li
                                    id="tab-disenio"
                                    onClick={() => onChangeMenu("disenio")}
                                    className="color-normal"
                                >
                                    Diseño
                                </li>
                                <li
                                    id="tab-rendimiento"
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="color-normal"
                                >
                                    Rendimiento
                                </li>
                                <li
                                    id="tab-seguridad"
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="color-normal"
                                >
                                    Seguridad
                                </li>
                                <li
                                    id="tab-conveniencia"
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="color-normal"
                                >
                                    Conveniencia
                                </li>
                            </ul>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra">
                            <a
                                href="static/media/grandi10-sedan-ficha-tecnica.8a52fc41.pdf"
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Ficha</span>
                            </a>
                        </Col>
                        <Col
                            xs={3}
                            md={1}
                            className="text-center my-auto cont-extra pr-md-0"
                        >
                            <Link
                                to="/cotizador/grandi10sedan"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Cotizar</span>
                            </Link>
                        </Col>
                        <Col
                            xs={3}
                            md={1}
                            className="text-center my-auto cont-extra pr-md-0"
                        >
                            <Link
                                to="/test-drive/grandi10sedan"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Test Drive</span>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/***************************************** calidad ***************************************/}
            <section id="calidad">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">Grand i10 SD
                            </h2>
                            <h2 className="model-title">Mueve tus emociones</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                El Grand i10 ya está aquí y está creando oleadas de emoción con su atrevido estilo
                                urbano. Hyundai ha reinventado por completo el automóvil familiar, su estilizada
                                apariencia destaca entre la multitud y está perfectamente a la altura para viajes largos
                                en la familia y amigos.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="bg-black py-2 px-2 py-md-4 px-md-0">
                            <video
                                loop
                                controls
                                style={
                                    {
                                        position: "relative",
                                        width: "100%",
                                        objectFit: "cover",
                                    }
                                }
                            >
                                <source
                                    src={CalidadVideo}
                                    type="video/mp4"
                                />
                                Your browser does not support the video tag.
                            </video>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto order-2 order-md-1">
                                <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                                    Sé el primero en evolucionar
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    Con un diseño exuberante y tecnológico, brinda una facilidad inteligente para tu
                                    vida. Te ofrece mucho espacio para tú comodidad. Solo piensa en tu Grand i10 SD
                                    como un espacio cómodo al momento de manejar, que te sorprenderá con sus
                                    características de conveniencia, gran espacio y moderno diseño interior.
                                </p>
                            </Col>
                            <Col md={6} className="my-auto order-1 order-md-2">
                                <Image src={Deportivo} alt="grandi10-sd Deportivo" className="img-fluid2" fluid />
                            </Col>
                        </Row>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto">
                                <Image src={Espacioso} alt="grandi10-sd Espacioso" className="img-fluid2" fluid />
                            </Col>
                            <Col md={6} className="my-auto">
                                <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                                    Hecho para esos momentos perfectos
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    Hay mucho por hacer y el Grand i10 te ayuda a hacerlo con estilo. Es joven,
                                    deportivo y te enamorarás de él a primera vista. Trae un diseño moderno, un interior
                                    espacioso y versátil con opciones de conectividad, características de seguridad.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <h2 className="galeria-titulo my-3 pb-2 pb-md-4">Galería</h2>
                            <div>
                                <Swiper {...gallerySwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="grandi10-sd Slider 1"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            alt="grandi10-sd Slider 2"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="grandi10-sd Slider 3"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="grandi10-sd Slider 4"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="grandi10-sd Slider 5"
                                            className="galeria1"
                                        />
                                    </div>
                                </Swiper>
                                <Swiper {...thumbnailSwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="grandi10-sd Slider 1"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            alt="grandi10-sd Slider 2"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="grandi10-sd Slider 3"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="grandi10-sd Slider 4"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="grandi10-sd Slider 5"
                                            className="galeria2"
                                        />
                                    </div>
                                </Swiper>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6}></Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    Diseño
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** disenio ***************************************/}
            <section id="disenio" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2>Diseño Exterior</h2>
                            <h2 className="model-title">Joven y Atrevido</h2>
                            <p className="model-text mt-3 px-3 px-md-0">
                                El Grand i10 sedán es atrevido en diseño, conectividad equipamiento y espacio. ¿Te
                                atrevés a conocer más?

                                Su diseño exterior, trae un estilo joven, deportivo y estilizado. Desde la gran apertura
                                de refrigeración hasta las líneas de carácter masculino que recorren el capó, cada
                                detalle refleja atletismo decidido. Los faros inclinados hacia atrás y las lentes de
                                proyección transmiten una sensación de alta tecnología a la vez que la parrilla estilo
                                cascada, agregan un toque premium.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <Container style={{ minHeight: '300px' }} className="cotizador pb-5">
                    <a href="https://my.matterport.com/show/?m=bM5bvVKY9bz" target="_blank" rel="noopener noreferrer">
                        <center>
                            <Image src={ShowRoom} alt="Showroom Virtual Grand i10 Sedan" fluid width={700} height={350} />
                        </center>
                    </a>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={12} className="text-center">
                                <h2 className="specs-subtitle mt-4 px-3 px-md-0">
                                    Diseño Interior
                                </h2>
                                <h3 className=" pb-3"> Comodidad en cada rincón</h3>

                                <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                    Te vas a sorprender de todo lo que ofrece el Grand i10 sedán, no solo por su
                                    renovado y elegante diseño, sino por el confort que hace que todos los pasajeros
                                    viajen cómodos.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={4}>
                            <Image src={Interior2} alt="grandi10-sd Banner" fluid />
                            <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                Computador a bordo
                            </h3>
                        </Col>
                        <Col md={4}>
                            <Image src={Interior3} alt="grandi10-sd Banner" fluid />
                            <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                Pantalla táctil de 9" Apple Car Play/ Android Auto
                            </h3>
                        </Col>
                        <Col md={4}>
                            <Image src={Interior4} alt="grandi10-sd Banner" fluid />
                            <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                Control de audio al volante
                            </h3>
                        </Col>
                    </Row>
                    <Row className="mb-3 pt-5">
                        <Col md={6}>
                            <Image src={Interior5} alt="grandi10-sd Banner" fluid />
                            <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                Aire acondicionado manual
                            </h3>
                        </Col>
                        <Col md={6}>
                            <Image src={Interior6} alt="grandi10-sd Banner" fluid />
                            <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                Panel de forma paramétrica y rejillas de ventilación en forma de hélice deportivo
                            </h3>
                        </Col>
                    </Row>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <Image src={Interior7} alt="grandi10-sd Interior" fluid />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("calidad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Calidad de tiempo
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    Rendimiento
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** rendimiento ***************************************/}
            <section id="rendimiento" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">Potencia y desempeño
                            </h2>
                            <h3>Compacto con gran rendimiento</h3>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                El Grand i10 Sedán cuenta con su nuevo motor Kappa de 1.2 litros el cual es
                                económico y confiable, aparte de comprometer su potencia. Este moderno motor ha sido
                                mejorado para aumentar el rendimiento a velocidades medias y fue optimizado para reducir
                                su nivel de ruido y vibraciones.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Image src={rendimiento2} alt="grandi10-sd Conduccion" fluid />
                            <h3 className="model-text mt-3 mb-0 px-3 px-md-0">Motor Tipo Kappa 1,2L MPI</h3>
                            <h3 className="model-text mb-0 px-3 px-md-0">Potencia máxima (hp@rpm) 82@6000</h3>
                            <h3 className="model-text mb-0 px-3 px-md-0">Torque máximo (Nm@rpm) 114@4000 </h3>
                            <h3 className="model-text mb-0 px-3 px-md-0">Sistema de distribución Cadena</h3>
                        </Col>
                        <Col md={6}>

                            <Image src={rendimiento1} alt="grandi10-sd Conduccion" fluid />
                            <h3 className="model-text mt-3 mb-0 px-3 px-md-0">Transmisión Manual 5 velocidades +
                                reversa</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Image className="mt-5" src={rendimiento3} alt="grandi10-sd Conduccion" fluid />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Diseño
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    Seguridad
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** seguridad ***************************************/}
            <section id="seguridad" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title px-3 px-md-0">Seguridad y Confort en movimiento</h2>
                            <h3> Protección en la que se puede confiar </h3>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Los dispositivos de seguridad, como los airbags dobles, sistema antibloqueo de frenado
                                (ABS), control electrónico de estabilidad (ESC) y asistente de arranque en pendiente
                                (HAC) proporcionan una gran seguridad para los ocupantes, esta construido con acero de
                                alta resistencia y garantiza una seguridad completa para todos los pasajeros.
                            </p>
                        </Col>
                    </Row>
                    <Row className="pb-md-5"
                    >
                        <Col md={6} className="py-3">
                            <Image src={seguridad1} alt="grandi10-sd Seguro" fluid />
                            <h3 className="model-text mt-3 mb-0 px-3 px-md-0">6 Airbags (conductor y pasajero + tórax y pelvis + cortina)
                            </h3>
                        </Col>
                        <Col md={6} className="py-3">
                            <Image src={seguridad2} alt="grandi10-sd Seguro" fluid />
                            <h3 className="model-text mt-3 mb-0 px-3 px-md-0">Cámara de reversa
                            </h3>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing ">
                    <Container>
                        <Row className="pb-md-5  pt-md-5">
                            <Col md={6}>
                                <Image src={seguridad3} alt="grandi10-sd Seguro" fluid />
                                <h3 className="model-text mt-3 mb-0">Sistema antibloqueo de frenado (ABS)
                                </h3>
                                <h3 className="model-text mt-3 mb-0">Control Electrónico de estabilidad (ESC)
                                </h3>
                            </Col>
                            <Col md={6}>
                                <Image src={seguridad4} alt="grandi10-sd Seguro" fluid />
                                <h3 className="model-text mt-3 mb-0 px-3 px-md-0">Asistente de arranque en pendiente
                                    (HAC)
                                </h3>
                                <h3 className="model-text mt-3 mb-0 px-3 px-md-0">No te preocupes, tu auto no se
                                    desplazara
                                    hacia atrás en el momento de iniciar la marcha adelante en una pendiente
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="pb-md-5  pt-md-5">
                        <Col md={6} className="py-3">
                            <Image src={seguridad5} alt="grandi10-sd Seguro" fluid />
                            <h3 className="model-text mt-3 mb-0 px-3 px-md-0">Sistema de anclaje para silla de niños
                                ISOFIX
                            </h3>
                        </Col>
                        <Col md={6} className="py-3 px-md-0 text-center">
                            <Image src={seguridad6} alt="grandi10-sd Seguro" fluid />
                            <h3 className="model-text mt-3 mb-0 px-3 px-md-0">
                                Carrocería con deformación programada
                            </h3>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Rendimiento
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="titulo-navegacion"
                                >
                                    Conveniencia
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** conveniencia ***************************************/}
            <section id="conveniencia" className="d-none">
                <Container className="pt-4 pt-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">Toma el control del camino</h2>
                            <p className="model-text mb-md-4 mt-3 px-3 px-md-0">
                                Disfruta de la comodidad, control y elegancia con características tecnológicas centradas
                                en que el conductor disfrute una experiencia de manejo única. Sus componentes
                                tecnológicos de última generación te mantienen conectado y te dan más claridad al
                                recorrer el camino.

                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} className="mt-4">
                            <Image src={conveniencia1} alt="grandi10-sd Volante" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Llave tipo navaja
                            </p>
                        </Col>
                        <Col md={4} className="mt-4">
                            <Image src={conveniencia2} alt="grandi10-sd Volante" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Espacio de maletero superior 402 L
                            </p>
                        </Col>
                        <Col md={4} className="mt-4">
                            <Image src={conveniencia3} alt="grandi10-sd Volante" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Volante regulable en altura
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} className="mt-4">
                            <Image src={conveniencia4} alt="grandi10-sd Volante" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Vidrios elétricos delanteros y posteriores
                            </p>
                        </Col>
                        <Col md={4} className="mt-4">
                            <Image src={conveniencia5} alt="grandi10-sd Volante" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Luz en el maletero
                            </p>
                        </Col>
                        <Col md={4} className="mt-4">
                            <Image src={conveniencia6} alt="grandi10-sd Volante" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Apoya cabezas en todos los asientos
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} className="mt-4">
                        </Col>
                        <Col md={4} className="mt-4">
                            <Image src={conveniencia7} alt="grandi10-sd Volante" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Asiento del conductor regulable en altura
                            </p>
                        </Col>
                        <Col md={4} className="mt-4">
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mt-4 mb-md-5">
                            <Image src={final_conveniencia} alt="grandi10-sd Volante" fluid />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Seguridad
                                </span>
                            </Col>
                            <Col xs={6} md={6}></Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </Fragment>
    );
}
export default InfoGrandi10Sedan2023;